import {
  SET_MODAL_CONFIG,
  CLEAR_MODAL_CONFIG,
  OPEN_SERVICES_MODAL,
  CLOSE_SERVICES_MODAL,
  CHANGE_MODAL_CONFIG,
  SET_CARD_LOADING_STATE,
} from '../actions/types';

const INITIAL_STATE = {
  isModalOpen: false,
  patchInfo: null,
  openPlacesModalFrom: null,
  theme: '',
  loading: {},
};

export default (state = INITIAL_STATE, action) => {
  const { patchInfo, modalType, theme, data } = action;
  switch (action.type) {
    case SET_MODAL_CONFIG:
      return {
        ...state,
        patchInfo,
        theme,
        openPlacesModalFrom: modalType,
      };
    case CLEAR_MODAL_CONFIG:
      return {
        ...INITIAL_STATE,
      };
    case CHANGE_MODAL_CONFIG:
      return {
        ...state,
        theme,
      };
    case OPEN_SERVICES_MODAL:
      return {
        ...state,
        isModalOpen: true,
      };
    case CLOSE_SERVICES_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };
    case SET_CARD_LOADING_STATE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [data.id]: data.state,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/addToDayModalReducer.js